import { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { UserCard } from 'components/User'
import ApplicationContext from 'contexts/application-context'
import ApplicationLayout from 'Layouts/Application'
import PageTitle from 'components/_utils/PageTitle'
import Tip from 'components/Tip'
import Input from 'components/Input'
import Button from 'components/Buttons'
import Plug from 'components/Plug'

// icons
import SearchIcon from 'components/StaticIcons/Search'
import FriendsIcon from 'components/StaticIcons/Navigation/Friends'

import {
  Content,
  Grid
} from './Styles'
import { IPublicStruct } from 'interfaces/IPublicStruct'

export default function ApplicationFriendsPage() {

  const ApplicationCtx = useContext(ApplicationContext)
  const { t, i18n } = useTranslation()

  const UserData: IPublicStruct = {
    user: {
      name: 'Butterbean',
      location: 'New York, USA',
      avatar: {
        src: 'https://theprime.gg/favicon.ico',
        size: 'middle'
      },
      languages: ["uk", "pl"]
    },
    info: [{
      title: 'K/D',
      description: <Tip />
    }, {
      title: 'Main role',
      description: 'Lurker'
    }, {
      title: 'Best agent',
      description: 'Jett'
    }, {
      title: 'Rank',
      description: 'Diamond 2'
    }]
  }

  const [isHaveFriends, setIsHaveFriend] = useState(false)

  return (
    <ApplicationLayout>
      <Content className={!isHaveFriends ? 'allCenter' : ''}>

        {isHaveFriends
        ?
          <>
            <PageTitle count={3}>Friend requests</PageTitle>
            <Grid>
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
            </Grid>

            <PageTitle count={3}>Your friends</PageTitle>
            <Input leftElement={<SearchIcon />} placeholder="Search user" />
            <Grid>
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
              <UserCard data={UserData} buttons={[<Button variable="solid" height="small">X</Button>, <Button variable="outline" height="small">Y</Button>]} />
            </Grid>
          </>
        :
          <>
            <Plug image={<FriendsIcon />} title={t('plugs.noFriends.title')} description={t('plugs.noFriends.description')} />
            <br /><br />
            <Button onClick={() => setIsHaveFriend(true)} variable="solid" height="big">{t('btns.searchPlayers')}</Button>
          </>
        }
  
      </Content>
    </ApplicationLayout>
  )
} 